export default "__VITE_ASSET__45689d72__"